import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import {api} from '../../../api/api-dictionnary';
import {HydraCollection, HydraCollectionInterface} from '../../../class/generic/hydra-collection';
import {HydraService} from '../../../core/services/hydra.service';
import {ActivityInterface} from '../../../class/api/Activity';
import {AuthentificationService} from '../../../core/services/authentification.service';

import { MatBadge } from '@angular/material/badge';
import { MatRipple } from '@angular/material/core';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-task-counter',
    templateUrl: './task-counter.component.html',
    styleUrls: ['./task-counter.component.scss'],
    imports: [MatBadge, MatRipple, RouterLink, MatIcon]
})
export class TaskCounterComponent implements OnInit, AfterViewInit {
    private hydraService = inject(HydraService);
    private authService = inject(AuthentificationService);


    public initComplete = false;

    private _action: string;
    private _actionArray: string[];
    public primaryCount = 0;
    public secondaryCount: number | null = null;


    @Input() set action(action: string) {
        this._action = action ?? '';
        if (this.initComplete) {
            this.loadTasksATraiter();
        }
    };

    @Input() set actionArray(actions: string[]) {
        this._actionArray = actions ?? [];
        if (this.initComplete) {
            this.loadTasksATraiter();
        }
    };

    private _target: string;
    @Input() set target(target: string) {
        this._target = target ?? '';
        if (this.initComplete) {
            this.loadTasksATraiter();
        }
    };

    @Input() label = 'A traiter';
    @Input() linkTarget = '#';
    @Input() showIfNone = true;
    @Input() icon = 'warning';
    @Output() numberTasks = new EventEmitter<number>();

    // plus gourmand en performance ! (en attendant gestion côté back)
    @Input() showInChargeBadge = false;


    constructor() {
    }

    ngOnInit(): void {
    }

    ngAfterViewInit() {
        this.loadTasksATraiter();
        this.initComplete = true;
    }

    public todoCount = 0;
    public myCount = 0;

    public loadTasksATraiter(): void {
        let url = api.activities + '?taskComplete=false&task=true';

        if(this.showInChargeBadge){
            url += '&pagination=false';
        }else{
            url += '&itemsPerPage=0';
        }

        if (this._target && this._target.length) {
            url += '&target=' + this._target;
        }

        if (this._action && this._action.length) {
            url += '&action=' + this._action;
        }

        if (this._actionArray  && this._actionArray.length > 0) {
            this._actionArray.forEach(action => {
                url += '&action[]=' + action;
            })
        }

        this.hydraService.getList(url).subscribe((res: HydraCollectionInterface) => {
            this.todoCount = res['hydra:totalItems'];

            if(this.showInChargeBadge){
                const items: ActivityInterface[] = new HydraCollection(res).getMember();
                this.myCount = items.reduce(
                    (acc, item) => HydraService.assertItemsAreSameResource(item.userInCharge, this.authService.userConnected) ? acc+1 : acc ,
                    0
                );
            }

            this.primaryCount   = this.showInChargeBadge ? this.myCount : this.todoCount;
            this.secondaryCount = this.showInChargeBadge ? this.todoCount : null;

            this.numberTasks.emit(this.todoCount);
        });
    }
}
